import React from 'react'
import className from 'classnames/bind'
import { useHistory } from 'react-router'

import style from './MyhouseInsuranceHeader.module.scss'

const cx = className.bind(style)

type Props = {
  isEnrol: boolean
}

const MyhouseInsuranceHeader: React.FC<Props> = ({ isEnrol }: Props) => {
  const history = useHistory()

  const handleCancelClick = (evt: React.SyntheticEvent) => {
    evt.preventDefault()
    evt.stopPropagation()

    history.goBack()
  }

  return (
    <>
      {isEnrol ? (
        <header className={cx('header_myhouse')}>
          <div className={cx('header_myhouse_inner')}>
            <h1 className={cx('header_myhouse_title')}>우리집 보험 등록</h1>
            <a href="#" className={cx('header_myhouse_link', 'type_cancel')} onClick={handleCancelClick}>
              취소
            </a>
          </div>
        </header>
      ) : (
        <header className={cx('header_myhouse')}>
          <div className={cx('header_myhouse_inner')}>
            <h1 className={cx('header_myhouse_title')}>우리집 보험 수정</h1>
            <a href="#" className={cx('header_myhouse_link', 'type_cancel')} onClick={handleCancelClick}>
              취소
            </a>
          </div>
        </header>
      )}
    </>
  )
}

export default MyhouseInsuranceHeader
